export const mrdRouteDef = [ 
    {
        path:':resource/:id/:resource/set',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine'
        }
    }    
]       